// extracted by mini-css-extract-plugin
export default {"jobList":"VacancyList_jobList__N96Wc","grid":"VacancyList_grid__9Gl8l"};